"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ChatPanel;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const subscription_1 = require("../../store/selectors/subscription");
const ChatMessages_1 = __importDefault(require("../../screen/OneToOneChat/ChatMessages"));
const Header_1 = __importDefault(require("./Header"));
const SummaryInput_1 = __importDefault(require("../SummaryInput"));
const colors_1 = require("../../common/colors");
const borders_1 = require("../../common/borders");
const UpgradeBanner_1 = __importDefault(require("../UpgradeBanner"));
function ChatPanel({ conversation }) {
    const conversationQuota = (0, react_redux_1.useSelector)(subscription_1.selectConversationQuota);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.container, children: [(0, jsx_runtime_1.jsx)(Header_1.default, {}), (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { colors: [colors_1.Colors.DARK_600, colors_1.Colors.DARK_700], style: styles.chatBackground, children: (0, jsx_runtime_1.jsx)(ChatMessages_1.default, { conversation: conversation }) }), conversationQuota?.consumed === conversationQuota?.quota ? ((0, jsx_runtime_1.jsx)(UpgradeBanner_1.default, {})) : ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.inputSpacing, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(SummaryInput_1.default, { autoFocus: true }) }) }))] }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        borderWidth: 1,
        borderColor: colors_1.Colors.DARK_600,
        borderRadius: borders_1.Borders.RADIUS_2XL,
    },
    chatBackground: {
        flex: 1,
    },
    inputSpacing: {
        padding: 16,
        paddingTop: 0,
    },
});
